import { pickLocalized } from './localized';
import { PAGE_META_EN } from './pageMeta.en';

export type PageMetaEntry = {
  title: string;
  description: string;
  ogImage?: string;
};

export const PAGE_META: Record<string, PageMetaEntry> = {
  home: {
    title: 'Luminary Business Solutions | ERP ve Dijital Dönüşüm Danışmanlığı',
    description:
      'Logo Yazılım sertifikalı çözüm ortağı ve Logosoft çözüm ortağı. SAP B1, Logo ERP ve dijital dönüşüm danışmanlığı.',
    ogImage: '/images/cta002.jpg',
  },
  cozumler: {
    title: 'Çözümler | Luminary Business Solutions',
    description:
      'SAP B1, Logo ERP, DNAsoft, Boyum-IT, Computec, Coresystems çözümleri; Logosoft ortaklığıyla Microsoft, güvenlik ve altyapı.',
    ogImage: '/images/sap004.jpg',
  },
  cozumlerLogo: {
    title: 'Logo ERP | Luminary Business Solutions',
    description: 'Logo Yazılım sertifikalı çözüm ortağı — Logo Tiger, Go ve Start kurulum, entegrasyon ve destek.',
    ogImage: '/images/logo004.jpg',
  },
  cozumlerLogosoft: {
    title: 'Logosoft | Luminary Business Solutions',
    description:
      'Logosoft kurumsal iş ortağı — Microsoft 365, Azure, Dynamics 365, güvenlik, altyapı, yapay zeka, IoT ve Huawei çözümlerinde danışmanlık ve uygulama.',
    ogImage: '/images/logosoft002.jpg',
  },
  cozumlerLogosoftOrtakligi: {
    title: 'Logosoft | Luminary Business Solutions',
    description:
      'Logosoft kurumsal iş ortağı — Microsoft 365, Azure, Dynamics 365, güvenlik, altyapı, yapay zeka, IoT ve Huawei çözümlerinde danışmanlık ve uygulama.',
    ogImage: '/images/logosoft002.jpg',
  },
  cozumlerSap: {
    title: 'SAP B1 | Luminary Business Solutions',
    description:
      'SAP Business One — gerçek zamanlı ERP, entegre iş zekası ve esnek dağıtım. Luminary sertifikalı implementasyon, Boyum/Computec/Coresystems ekosistemi ve ProSoft entegrasyonları.',
    ogImage: '/images/sap004.jpg',
  },
  cozumlerBoyum: {
    title: 'Boyum-IT | Luminary Business Solutions',
    description:
      'SAP B1 eklentileri: Beas Manufacturing, Produmex WMS, Perfion PIM, üretim çizelgeleme, B1 Usability ve daha fazlası.',
    ogImage: '/images/boyum002.jpg',
  },
  cozumlerComputec: {
    title: 'Computec | Luminary Business Solutions',
    description:
      'CompuTec ProcessForce, PDC, WMS, Labels, AppEngine, WebUp ve Holo — SAP B1 gelişmiş üretim ve lojistik entegrasyonu.',
    ogImage: '/images/computec002.jpg',
  },
  cozumlerCoresystems: {
    title: 'Coresystems | Luminary Business Solutions',
    description:
      'Coresystems FSM, InsightLoop, ChronoHub ve Coresuite — Service AI ve SAP Business One entegrasyonlu servis çözümleri.',
    ogImage: '/images/coresystems001.jpg',
  },
  cozumlerDnasoft: {
    title: 'DNAsoft | Luminary Business Solutions',
    description:
      'DNAsoft CAF konfeksiyon MRP ve KAF profil/metal/plaka MRP. İki bağımsız sektörel yazılım — hangisi size uygun?',
    ogImage: '/images/dnasoft001.jpg',
  },
  cozumlerDnasoftCaf: {
    title: 'DNAsoft CAF | Konfeksiyon MRP | Luminary',
    description:
      'CAF: hazır giyim ve konfeksiyon MRP. Renk–beden–boy, asorti, pastal, kazan takibi ve Logo Tiger entegrasyonu.',
    ogImage: '/images/dnasoft001.jpg',
  },
  cozumlerDnasoftKaf: {
    title: 'DNAsoft KAF | Profil & Plaka MRP | Luminary',
    description:
      'KAF: alüminyum, PVC, çelik ve plaka MRP. Kg–boy–plaka çevrimi, RAL/eloksal varyantları ve Logo Tiger entegrasyonu.',
    ogImage: '/images/dnasoft001.jpg',
  },
  cozumlerYapayZeka: {
    title: 'Yapay Zeka | Luminary Business Solutions',
    description:
      'ERP verisi üzerinde yapay zeka, otomasyon ve analitik. İş hedefi danışmanlığı, yetkin uygulama ekibi ve ihtiyaca özel çözüm tasarımı.',
    ogImage: '/images/probi/probi-dashboard-viewer.png',
  },
  hizmetler: {
    title: 'Hizmetler | Luminary Business Solutions',
    description: 'ERP danışmanlığı, implementasyon, destek, eğitim ve özel yazılım geliştirme.',
    ogImage: '/images/hizmetler-hero-v2.jpg',
  },
  urunler: {
    title: 'ProSoft Ürünler | Luminary Business Solutions',
    description:
      'ProIntercompany ve ProMES (SAP B1), ProMobile mobil WMS (SAP B1), ProBank (SAP B1 · Logo · Promax), ProBI ve ProHR (platform bağımsız) — ProSoft ürün ailesi.',
    ogImage: '/images/probi/probi-dashboard-viewer.png',
  },
  urunlerProintercompany: {
    title: 'ProIntercompany | SAP B1 Şirketler Arası Entegrasyon',
    description: 'SAP B1 için şirketler arası entegrasyon ve otomatik veri aktarımı.',
    ogImage: '/images/prointer003.jpg',
  },
  urunlerProbi: {
    title: 'ProBI | Luminary Business Solutions',
    description:
      "Platform bağımsız iş zekası: Designer & Viewer, 18'den fazla SQL kaynağı, interaktif veri keşfi ve gelişmiş analitik.",
    ogImage: '/images/probi/probi-dashboard-viewer.png',
  },
  urunlerProbank: {
    title: 'ProBank | Luminary Business Solutions',
    description: 'Banka mutabakatı ve otomatik eşleştirme — SAP B1, Logo ve Promax ile entegre.',
    ogImage: '/images/probank-ui.png',
  },
  urunlerProhr: {
    title: 'ProHR | Luminary Business Solutions',
    description: 'Platform bağımsız İK, bordro ve personel yönetimi.',
    ogImage: '/images/prohr002.jpg',
  },
  urunlerPromes: {
    title: 'ProMES & IoT | Luminary Business Solutions',
    description: 'SAP B1 ile entegre üretim takip, MES ve IoT sensör entegrasyonu.',
    ogImage: '/images/promes002.jpg',
  },
  urunlerPromobile: {
    title: 'ProMobile | Luminary Business Solutions',
    description:
      'SAP B1 ile canlı entegre mobil WMS — mal kabul, depo içi hareket, akıllı sevkiyat ve raf adresi takibi.',
    ogImage: '/images/promobile002.jpg',
  },
  iletisim: {
    title: 'İletişim | Luminary Business Solutions',
    description: 'Proje danışmanlığı ve destek için Luminary ekibiyle iletişime geçin.',
    ogImage: '/images/iletisim-hero-001.jpg',
  },
  destekIndir: {
    title: 'İndir | Luminary Business Solutions',
    description: 'ProBI, ProBank, ProHR, ProMES ve DNAsoft CAF/KAF paketlerini doğrudan indirin.',
    ogImage: '/logo.png',
  },
  hakkimizda: {
    title: 'Hakkımızda | Luminary Business Solutions',
    description: "2008'den bu yana ERP danışmanlığı. Luminary Yazılım ve Danışmanlık — İstanbul.",
    ogImage: '/images/hakkimizda-hero-001.jpg',
  },
  notFound: {
    title: 'Sayfa Bulunamadı | Luminary Business Solutions',
    description: 'Aradığınız sayfa mevcut değil. Luminary Business Solutions ana sayfasına dönün.',
  },
  gizlilik: {
    title: 'Gizlilik Politikası | Luminary Business Solutions',
    description: 'KVKK kapsamında kişisel verilerin işlenmesi, iletişim formu ve bilgi asistanı veri aktarımı.',
  },
  cerezler: {
    title: 'Çerez Politikası | Luminary Business Solutions',
    description: 'Web sitesinde kullanılan çerezler, analitik onayı ve tercih yönetimi.',
  },
  en: {
    title: 'English | Luminary Business Solutions',
    description: 'ERP consulting and ProSoft products — SAP Business One, Logo, Istanbul-based since 2008.',
    ogImage: '/images/cta002.jpg',
  },
};

export function getPageMeta(lang: string | undefined, pageKey: PageMetaKey): PageMetaEntry {
  return pickLocalized(lang, PAGE_META[pageKey], PAGE_META_EN[pageKey] ?? PAGE_META[pageKey]);
}

export type PageMetaKey = keyof typeof PAGE_META;
